import { render, staticRenderFns } from "./FafBigChart.vue?vue&type=template&id=0d2dab99&scoped=true&"
import script from "./FafBigChart.vue?vue&type=script&lang=js&"
export * from "./FafBigChart.vue?vue&type=script&lang=js&"
import style0 from "./FafBigChart.vue?vue&type=style&index=0&id=0d2dab99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2dab99",
  null
  
)

export default component.exports